const options = {
  5: "bg-amber-50/5",
  10: "bg-amber-50/10",
  25: "bg-amber-50/25",
  50: "bg-amber-50/50",
  75: "bg-amber-50/75",
  90: "bg-amber-50/90",
  100: "bg-amber-50",
};

const from = {
  5: "from-amber-50/5",
  10: "from-amber-50/10",
  25: "from-amber-50/25",
  50: "from-amber-50/50",
  75: "from-amber-50/75",
  90: "from-amber-50/90",
  100: "from-amber-50",
};

export default function getBackgroundAmber50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
